import { IColumnsItem } from '@/components/custom-table/type.d';
import { IGetCanalErrorLogsRes } from '@/api/goods-service/type.d';
import { IFilters } from '@/core/plugins/filter';
import { GOODS_SERVICE_ERROR_LOG_STATE_LIST, GOODS_SERVICE_ERROR_LOG_STATE_ENUM } from '@/constant';

export const renderColumns = (
  handleSyncItem: (id: string) => void,
  filters: IFilters,
  canSync: boolean,
): IColumnsItem<IGetCanalErrorLogsRes['list'][0]>[] => [
  {
    label: '消息ID',
    prop: 'id',
    width: '80',
  },
  {
    label: '创建时间',
    width: '110',
    render: row => <div>{filters.formatTime(row.createdTime)}</div>,
  },
  {
    label: 'DDL',
    width: '60',
    render: row => <div>{row.isDdl === '1' ? '是' : '否'}</div>,
  },
  {
    label: '数据库',
    prop: 'database',
    width: '160',
  },
  {
    label: '数据表',
    prop: 'table',
    width: '90',
  },
  {
    label: 'SQL',
    prop: 'sql',
    width: '90',
    ellipsis: true,
  },
  {
    label: '旧数据',
    prop: 'old',
    width: '90',
    ellipsis: true,
  },
  {
    label: '内容',
    prop: 'data',
    width: '90',
    ellipsis: true,
  },
  {
    label: '操作类型',
    prop: 'type',
    width: '90',
    ellipsis: true,
  },
  {
    label: '主键列',
    prop: 'pkNames',
    width: '120',
  },
  {
    label: '表结构',
    prop: 'mysqlType',
    width: '90',
    ellipsis: true,
  },
  {
    label: '堆栈信息',
    width: '90',
    render: row => (
      <el-popover
        placement="right"
        trigger="click"
        v-slots={{
          reference: () => <div>点击显示</div>,
        }}
      >
        <div style="max-width:90vw;font-size:12px;line-height:18px">{row.stackTrace}</div>
      </el-popover>
    ),
  },
  {
    label: '状态',
    width: '90',
    render: row => (
      <div>{filters.getEnumLabel(GOODS_SERVICE_ERROR_LOG_STATE_LIST, row.handledState)}</div>
    ),
  },
  {
    label: '同步次数',
    prop: 'syncCount',
    width: '90',
  },
  {
    label: '操作',
    width: '100',
    align: 'center',
    fixed: 'right',
    render: row => (
      <div>
        {row.handledState === GOODS_SERVICE_ERROR_LOG_STATE_ENUM.HANDLE && (
          <el-button size="default" type="primary" disabled>
            已同步
          </el-button>
        )}
        {row.handledState !== GOODS_SERVICE_ERROR_LOG_STATE_ENUM.HANDLE && canSync && <el-button
            size="default"
            type="primary"
            onClick={() => handleSyncItem(row.logId)}
          >
            同步
          </el-button>}
      </div>
    ),
  },
];
